import React from "react";
import { Card, KeyValueList, LongTextLabel, Section } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { getNameFromSignatureProperties } from "../../../../utils";
import { IssuesList } from "../../../common";
import styles from "./certificateMetadata.module.scss";
const toValueMap = (properties) => Object.fromEntries(properties);
const CertificateMetadata = ({ certificate, validation, }) => {
    return (React.createElement(Card.Card, { className: styles.certificate },
        React.createElement(Card.Title, null,
            React.createElement(LongTextLabel, { label: `Certificate: ${getNameFromSignatureProperties(certificate.subject)}`, className: styles.title })),
        React.createElement(Card.Content, null,
            React.createElement("div", { className: styles.content },
                React.createElement(IssuesList, { violations: certificate.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, nested: true }),
                validation && validation.warnings.length > 0 ? (React.createElement(Section, null,
                    React.createElement(Section.Title, null, "Validation warnings"),
                    React.createElement(Section.Content, null, validation.warnings.map((warning, index) => (React.createElement("div", { key: index }, warning)))))) : null,
                React.createElement(KeyValueList, { list: [
                        "Details",
                        {
                            Version: certificate.version,
                            "Valid from": certificate.valid_from,
                            "Valid to": certificate.valid_to,
                            Serial: React.createElement("code", null, certificate.serial_number),
                            Algorithm: certificate.algorithm,
                            Thumbprint: React.createElement("code", null, certificate.thumbprint),
                        },
                        "Subject",
                        toValueMap(certificate.subject),
                        "Issuer",
                        toValueMap(certificate.issuer),
                        "Extensions",
                        Object.fromEntries(certificate.extensions.map((extension) => [
                            extension.name,
                            React.createElement(React.Fragment, { key: extension.name },
                                extension.value,
                                extension.is_critical && React.createElement("em", null, " (Critical)")),
                        ])),
                    ] })))));
};
export default CertificateMetadata;
//# sourceMappingURL=CertificateMetadata.js.map